import Vue from 'vue';
import moment from 'moment';
import { IUser, ICustomer } from './lib/interfaces';
import { ruMonth } from '@/lib/helpers/common.helper';

moment.locale('ru');

function isCustomer(user: IUser | ICustomer): user is ICustomer {
  return !!(user as ICustomer).name;
}

Vue.filter('fullName', (user: IUser | ICustomer) => {
  if (!user) {
    return '';
  }
  if ( isCustomer(user) ) {
    return user.name;
  }
  return `${user.fname} ${user.lname}`;
});

Vue.filter('avatarUrl', (user: IUser) => {
  if (!user) {
    return 'https://www.gravatar.com/avatar/?d=mp';
  }
  return `https://www.gravatar.com/avatar/${user.email_hash}?d=identicon`;
});

Vue.filter('date', (date: string) =>
  date ? moment(date).format('DD MMMM') : '',
);

Vue.filter('minDate', (date: string) =>
  date ? moment(date).format('D MMM') : '',
);

Vue.filter('fullDate', (date: string) =>
  date ? moment(date).format('LLL') : '',
);

Vue.filter('currYearDate', (date: string) => {
  const f = moment(date).format('YYYY').toString() === moment().year().toString() ? 'D MMM' : 'D MMM YYYY';
  const result = moment(date).format(f);
  return result;
});

Vue.filter('humanize', (date: string) =>
  date ? moment(date).fromNow() : '',
);

Vue.filter('minuteDur', (amount: number) => {
  let result = '';
  const hours = Math.floor(amount / 60);
  const mins = amount % 60;
  if (hours > 0) {
    result += `${hours} ч. `;
  }
  if (mins > 0) {
    result += `${mins} мин.`;
  }
  return result;
});

Vue.filter('logworkHours', (amount: number): string => {
  if (!amount) {
    return '-';
  }
  // parseFloat чтобы не было нулей
  return parseFloat( (amount / 60).toFixed(2) ).toString();
});

Vue.filter('ruMonth', (month: number): string => {
  if (month !== 0 && !month) {
    return '';
  }
  return ruMonth[month];
});
